<template>
  <date-range-picker
    :control-container-class="controlContainerClass"
    @update="onDateRangeApply"
    :ranges="ranges"
    opens="right"
    showWeekNumbers
    showDropdowns
    ref="picker"
    @toggle="onToggle"
    :locale-data="{ firstDay: 1, format: currentBranch.date_format}"
    v-model="model[`${attribute}_date_range`]"
    :disabled="disabled"
  >
    <template v-slot:input="picker" style="min-width: 350px;">
      <span v-if="!picker.startDate" class="text-muted">
        {{ computedPlaceholder }}
      </span>
      <span style="font-size: 10px" v-else>
        {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
      </span>
    </template>
    <div slot="footer" class="drp-buttons" slot-scope="data">
      <button @click="onCancelClick" type="button" class="cancelBtn btn btn-sm btn-default">Clear</button>
      <button @click="data.clickCancel" type="button" class="cancelBtn btn btn-sm btn-default">Cancel</button>
      <button @click="data.clickApply" type="button" class="applyBtn btn btn-sm btn-success">Apply</button>
    </div>
  </date-range-picker>
</template>

<script>
  import BaseModel from "@/core/components/input-widget/BaseModel";
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from "moment";
  import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";
  import {createNamespacedHelpers} from "vuex";
  import i18n from "../../../shared/i18n";
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "ArtisioDateRangerPicker",
    components: {DateRangePicker},
    props: {
      model: BaseModel,
      attribute: String,
      state: [Boolean],
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: [String, Boolean],
        default: null
      },
    },
    computed: {
      ...mapStateGlobal(['currentBranch']),
      controlContainerClass() {
        const invalidClass = this.state === false ? "is-invalid" : "";
        const disabledClass = this.disabled ? "ckeditor-disabled" : ""
        return `form-control reportrange-text ${invalidClass} ${disabledClass}`;
      },
      ranges() {
        let returnData = {}
        returnData[i18n.t("Today")] = [this.today, this.today]
        returnData[i18n.t("Yesterday")] = [this.yesterday, this.yesterday]
        returnData[i18n.t("This month")] = [new Date(this.today.getFullYear(), this.today.getMonth(), 1), new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0)]
        returnData[i18n.t("This year")] = [new Date(this.today.getFullYear(), 0, 1), new Date(this.today.getFullYear(), 11, 31)]
        returnData[i18n.t("Last Week")] = [new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - this.today.getDay() - 6), new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - this.today.getDay())]
        returnData[i18n.t("Last month")] = [new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1), new Date(this.today.getFullYear(), this.today.getMonth(), 0)]
        return returnData;
      },
      today() {
        let e = new Date;
        e.setHours(0, 0, 0, 0);
        return e;
      },
      yesterday() {
        let t = new Date;
        t.setDate(this.today.getDate() - 1);
        t.setHours(0, 0, 0, 0);
        return t;
      },
      computedPlaceholder() {
        return this.placeholder ? this.placeholder : this.$i18n.t('Date Range')
      }
    },
    methods: {
      onDateRangeApply() {
        const dateRange = this.model[`${this.attribute}_date_range`];
        let currentTzStartDate = moment(dateRange.startDate);
        let startDate = currentTzStartDate.format(SYSTEM_DATE_FORMAT)
        startDate = startDate === 'Invalid date' ? null : startDate
        let currentTzEndDate = moment(dateRange.endDate);
        let endDate = currentTzEndDate.format(SYSTEM_DATE_FORMAT)
        endDate = endDate === 'Invalid date' ? null : endDate
        if (startDate && endDate) {
          this.model[this.attribute] = `${startDate} - ${endDate}`;
        }
      },
      onCancelClick() {
        this.model[`${this.attribute}_date_range`] = {}
        this.model[this.attribute] = null
        this.$refs.picker.start = null
        this.$refs.picker.end = null
      },
      setDynamicMaxWidth() {
        this.$nextTick(() => {
          const pickerElement = this.$refs.picker.$el.querySelector('.daterangepicker');
          if (pickerElement) {
            const pickerRect = pickerElement.getBoundingClientRect();
            const marginRight = 10;
            const availableWidth = window.innerWidth - pickerRect.left - marginRight;
            pickerElement.style.maxWidth = `${availableWidth}px`;
          }
        });
      },
      onToggle(opened) {
        if (opened) {
          this.setDynamicMaxWidth();
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.vue-daterange-picker {
  width: 100%;

  /deep/ .daterangepicker {
    min-width: 0 !important;

    .calendars {
      flex-wrap: nowrap;
      overflow-x: auto;
    }
  }
}
</style>
